import HeroFeatured, { HeroFeaturedProps } from './HeroFeatured'
import { HeroFeaturedFloatingCardProps } from './HeroFeaturedFloatingCard'

export type { HeroFeaturedProps, HeroFeaturedFloatingCardProps }
export default HeroFeatured
